import React, { useEffect } from 'react';
import { Button, Container, Row, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import styles from '../../Measures.module.scss';
import { data } from '../../../data';

const IQITechnical = () => {
    useEffect(() => {
        // Update the document title using the browser API
        document.title = `AHRQ QI: IQI Technical Specifications Updates - Ver. 4.1, December 2009`;
      });
    return (<>

        <Container className='outerContainer'>
            <h1 className="centerText mb-5">Inpatient Quality Indicators Technical Specifications</h1>
        </Container>
        <Container className='outerContainer'>
        <h3 className="mb-5">Inpatient Quality Indicators Indicators Technical Specifications, Ver. 4.1, December 2009</h3>
            <Row>
                <Col md={8}>
                    <h4>All Inpatient Quality Indicators Technical Specifications, Version 4.1 (Zip File)</h4>
                </Col>
                <Col md={4} className={styles.downloadSpecBtn}>
                    <Button href='https://www.qualityindicators.ahrq.gov/Downloads/Modules/IQI/V41/TechSpecs/IQI_Technical_Specifications_FY09_Version41.zip'>Download All (.zip)</Button>
                </Col>
            </Row>
           
            <hr />
        </Container>

        <Container className='outerContainer'>
            <Table striped hover>
                <tbody >
                    {data.modules.filter((module) => module.topictag == "IQI-Indicators").map((information) => (<>
                        {information.indicators.map((info) => (<>
                            {info.previous && info.previous.filter((prev) => prev.version == "V4.1").map((prev) => (<>
                                <tr>
                                    <td><a href={prev.url}>{prev.name}</a></td>
                                </tr>
                            </>))}
                        </>))}
                   

                    </>))}
                </tbody>
            </Table>
        </Container>


    </>)
}

export default IQITechnical;